// extracted by mini-css-extract-plugin
export default {"PurpleBox":"PurpleBox1pAZf9OCE9gO"};